<form #updatePacienteForm="ngForm">
  <app-custom-modal #modal [title]="'Editar Paciente'" [subtitle]="''" (onCloseClick)="modal.close()"
    (onSaveClick)="save()" [saveLabel]="'Salvar'" [saveDisabled]="updatePacienteForm.invalid"
    [customButtonDisabled]="updatePacienteForm.invalid" [showCustomButton]="showBotaoImprimir"
    [customButtonLabel]="'Salvar & Imprimir'" (onCustomButtonClick)="save(true)">
    <div class="container">
      <tabset>
        <tab heading="Dados do Paciente" customClass="pt-7">
          <div class="form-group row">
            <label class="col-md-3 col-form-label required" for="name">
              {{ "Name" | localize }}
            </label>
            <div class="col-md-9">
              <input type="text" class="form-control" name="name" id="name" required maxlength="64"
                [(ngModel)]="paciente.nome" #nameModel="ngModel" #nameEl autocomplete="off" />
              <mat-hint><strong>Tamanho máximo</strong> </mat-hint>
              <mat-hint> {{nameEl.value.length}}/64</mat-hint>
              <abp-validation-summary [control]="nameModel" [controlEl]="nameEl"></abp-validation-summary>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="nomeSocial">
              Nome Social
            </label>
            <div class="col-md-9">
              <input type="text" class="form-control" name="nomeSocial" id="nomeSocial" maxlength="100"
                [(ngModel)]="paciente.nomeSocial" #nomeSocialModel="ngModel" #nomeSocialEl autocomplete="off" />
              <mat-hint><strong>Tamanho máximo</strong> </mat-hint>
              <mat-hint> {{nomeSocialEl.value.length}}/100</mat-hint>
              <abp-validation-summary [control]="nomeSocialModel" [controlEl]="nomeSocialEl"></abp-validation-summary>
            </div>
          </div>
          <div class="form-group row mt-2">
            <label class="col-md-3 col-form-label" for="nomeMae">Nome da mãe</label>
            <div class="col-md-9">
              <input type="text" class="form-control" name="nomeMae" id="nomeMae" [(ngModel)]="paciente.nomeMae"
                #nomeMaeModel="ngModel" #nomeMaeEl [ngModelOptions]="{ standalone: true }" />
              <abp-validation-summary [control]="nomeMaeModel" [controlEl]="nomeMaeEl"></abp-validation-summary>
            </div>

          </div>

          <div class="form-group row mt-2">
            <label class="col-md-3 col-form-label" for="religiao">Religião</label>
            <div class="col-md-9">
              <input type="text" class="form-control" name="religiao" id="religiao" [(ngModel)]="paciente.religiao"
                #religiaoModel="ngModel" #religiaoEl [ngModelOptions]="{ standalone: true }" />
              <abp-validation-summary [control]="religiaoModel" [controlEl]="religiaoEl"></abp-validation-summary>
            </div>
          </div>

          <div class="form-group row mt-2">
            <label class="col-md-3 col-form-label" for="ProfissaoResponsavelLegal">Profissão</label>
            <div class="col-md-9">
              <input type="text" class="form-control" name="Profissao" id="Profissao" [(ngModel)]="paciente.profissao"
                #profissaolLegalModel="ngModel" #profissaoLegalEl [ngModelOptions]="{ standalone: true }" />
              <abp-validation-summary [control]="profissaolLegalModel"
                [controlEl]="profissaoLegalEl"></abp-validation-summary>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="name">
              {{ "Sexo" | localize }}
            </label>
            <div class="col-md-9">
              <select class="custom-select kt-input" name="sexo" [(ngModel)]="paciente.sexo" [value]="undefined"
                #sexoModel="ngModel" #sexoEl>
                <option *ngFor="let sexo of listaSexo" [ngValue]="sexo.value">
                  {{ sexo.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row mt-2">
            <label class="col-md-3 col-form-label" for="tipoSanguineo">
              Tipo Sanguíneo
            </label>
            <div class="col-md-9">
              <select class="custom-select kt-input select-with-placeholder" name="tipoSanguineo"
                [(ngModel)]="paciente.tipoSanguineo" #tipoSanguineoModel="ngModel" #tipoSanguineoEl>
                <option *ngFor="let tipo of listaTipoSanguineo" [ngValue]="tipo.value">
                  {{ tipo.name }}
                </option>
              </select>
              <abp-validation-summary [control]="tipoSanguineoModel"
                [controlEl]="tipoSanguineoEl"></abp-validation-summary>
            </div>
          </div>

          <div class="form-group row mt-2">
            <label class="col-md-3 col-form-label" for="corEtnia">
              Cor/Etnia
            </label>
            <div class="col-md-9">
              <select class="custom-select kt-input select-with-placeholder" name="corEtnia"
                [(ngModel)]="paciente.corEtnia" #corEtniaModel="ngModel" #corEtniaEl>
                <option *ngFor="let corEtnia of listaCorEtnia" [ngValue]="corEtnia.value">
                  {{ corEtnia.name }}
                </option>
              </select>
            </div>
            <abp-validation-summary [control]="corEtniaModel" [controlEl]="corEtniaEl"></abp-validation-summary>
          </div>
          <div class="form-group row mt-2">
            <label class="col-md-3 col-form-label" for="corEtnia">
              Estado Civil
            </label>
            <div class="col-md-9">
              <select class="custom-select kt-input select-with-placeholder" name="estadoCivil"
                [(ngModel)]="paciente.estadoCivil" #estadoCivilModel="ngModel" #estadoCivilEl>
                <option *ngFor="let estadoCivil of listaEstadoCivil" [ngValue]="estadoCivil.value">
                  {{ estadoCivil.name }}
                </option>
              </select>
            </div>
            <abp-validation-summary [control]="estadoCivilModel" [controlEl]="estadoCivilEl"></abp-validation-summary>
          </div>
          <div class="form-group row" *ngIf="!paciente.ehEstrangeiro">
            <label class="col-md-3 col-form-label" [ngClass]="!isDependente() ? 'required' : ''" for="cpf">
              {{ "Cpf" | localize }}
            </label>
            <div class="col-md-9">
              <input type="text" class="form-control" name="cpf" id="cpf" [required]="!isDependente()" maxlength="14"
                mask="000.000.000-00" [(ngModel)]="paciente.cpf" #cpfModel="ngModel" #cpfEl autocomplete="off"
                [disabled]="!editCpf" />
              <abp-validation-summary [control]="cpfModel" [controlEl]="cpfEl"></abp-validation-summary>
            </div>
          </div>
          <div class="form-group row" *ngIf="paciente.ehEstrangeiro">
            <label class="col-md-3 col-form-label" [ngClass]="!isDependente() ? 'required' : ''" for="passaporte">
              Número do passaporte
            </label>
            <div class="col-md-9">
              <input type="text" class="form-control" name="passaporte" id="passaporte" [required]="!isDependente()"
                [(ngModel)]="paciente.numeroPassaporte" 
                [disabled]="!editCpf" />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="cns">
              {{ "Cns" | localize }}
            </label>
            <div class="col-md-9">
              <input type="text" #cnsEl class="form-control" name="cns" id="cns" mask="000 0000 0000 0000"
                [(ngModel)]="cns" autocomplete="off" placeholder="000 0000 0000 0000" #cnsModel="ngModel"
                pattern="(\d{3})(\d{4})(\d{4})(\d{4})" (blur)="cnsOnBlur()" />
              <abp-validation-summary [control]="cnsModel" [controlEl]="cnsEl"
                [customValidationErrors]="newCnsValidationErrors"></abp-validation-summary>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="data-nascimento">
              {{ "DataNascimento" | localize }}
            </label>
            <div class="col-md-9">
              <input type="text" class="form-control" name="data-nascimento" id="data-nascimento" maxlength="10"
                [mask]="'d0/M0/0000'" [(ngModel)]="dataNascimento" (ngModelChange)="onSelectDate($event)"
                #dataNascimentoModel="ngModel" #dataNascimentoEl autocomplete="off" placeholder="dd/mm/aaaa"
                (blur)="dataNascimentoValida(dataNascimento)" />
              <abp-validation-summary [control]="dataNascimentoModel"
                [controlEl]="dataNascimentoEl"></abp-validation-summary>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label required" for="celular">
              {{ "Celular" | localize }}
            </label>
            <div class="col-md-9">
              <input type="text" class="form-control" required name="celular" id="celular" maxlength="15"
                mask="(00) 0000-0000||(00) 00000-0000" [(ngModel)]="paciente.celular" #celularModel="ngModel" #celularEl
                autocomplete="off" [disabled]="isDependente()" />
              <abp-validation-summary [control]="celularModel" [controlEl]="celularEl"></abp-validation-summary>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 col-form-label" for="email">
              {{ "EmailAddress" | localize }}
            </label>
            <div class="col-md-9">
              <input type="email" class="form-control" name="email" id="email" maxlength="256"
                [(ngModel)]="paciente.email" #emailModel="ngModel" #emailEl autocomplete="off"
                placeholder="usuario@email.com" />
              <mat-hint><strong>Tamanho máximo</strong></mat-hint>
              <mat-hint> {{emailEl.value.length}}/256</mat-hint>
              <abp-validation-summary [control]="emailModel" [controlEl]="emailEl"></abp-validation-summary>
            </div>
          </div>

          <div class="form-group row">
            <label *ngIf="cadEmail" class="col-md-3 col-form-label" for="emailAlt">
              E-mail Alternativo
            </label>
            <div class="col-md-9" *ngIf="cadEmail">
              <input type="email" class="form-control email-width" name="emailAlt" id="emailAlt" maxlength="256"
                [(ngModel)]="emailAlt" #emailModel="ngModel" #emailEl autocomplete="off"
                placeholder="usuario@email.com" />
              <div class="input-group-append icon-div">
                <div class="input-group-text p-4" style="cursor: pointer" (click)="addEmailLista(emailAlt)">
                  <span class="fas fa-plus"></span>
                </div>
              </div>
              <mat-hint><strong>Tamanho máximo</strong></mat-hint>
              <mat-hint> {{ emailEl.value.length }}/256</mat-hint>
              <abp-validation-summary [control]="emailModel" [controlEl]="emailEl"></abp-validation-summary>
            </div>
            <perfect-scrollbar *ngIf="paciente?.emailAlternativo?.length != 0" #perfectScroll
              style="position: relative;overflow-y: hidden; height: 200px !important;" [config]="{}"
              [scrollIndicators]="true">
              <table class="table table-hover text-nowrap mt-4">
                <thead class="bg-light">
                  <tr>
                    <th>{{ "E-mails Cadastrados" | localize }}</th>
                    <th *ngIf="paciente.responsavelLegalId == null" style="width: 50px;">{{ "Apagar" | localize }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let email of paciente.emailAlternativo">
                    <td>{{email.email}}</td>
                    <td class="text-center">
                      <button *ngIf="paciente.responsavelLegalId == null" [title]="'Delete' | localize" type="button"
                        class="btn btn-icon btn-light-danger btn-xs ml-2" (click)="removerLista(email)">
                        <i class="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </perfect-scrollbar>
            <div *ngIf="paciente.responsavelLegalId == null" class="text-center m-auto">
              <button class="m-auto text-center btn btn-primary" *ngIf="!cadEmail" (click)="isCad()">Adicionar
                e-mail</button>
            </div>
          </div>
        </tab>
        <tab *ngIf="paciente.enderecoAtualizado" heading="Endereço" customClass="pt-7">
          <div>
            <div class="form-group row">
              <label class="col-md-2" for="cep">
                {{ "Cep" | localize }}
              </label>
              <input type="text" class="form-control col-md-9" name="cep" id="cep" maxlength="10" mask="00.000-000"
                [ngModel]="paciente.enderecoAtualizado.cep" (ngModelChange)="onSelectCep($event)" #cepModel="ngModel"
                #cepEl />
              <abp-validation-summary [control]="cepModel" [controlEl]="cepEl"></abp-validation-summary>
            </div>
            <div class="form-group row">
              <label class="col-md-2" for="estado">
                {{ "Estado" | localize }}
              </label>
              <input type="text" class="col-md-9 form-control" name="estado" id="estado" maxlength="20"
                [(ngModel)]="paciente.enderecoAtualizado.estado" disabled="true" #estadoModel="ngModel" #estadoEl />
              <abp-validation-summary [control]="estadoModel" [controlEl]="estadoEl"></abp-validation-summary>
            </div>

            <div class="form-group row">
              <label class="col-md-2" for="cidade">
                {{ "Cidade" | localize }}
              </label>
              <input type="text" class="col-md-9 form-control" name="cidade" id="cidade" maxlength="80"
                [(ngModel)]="paciente.enderecoAtualizado.cidade" disabled="true" #cidadeModel="ngModel" #cidadeEl />
              <abp-validation-summary [control]="cidadeModel" [controlEl]="cidadeEl"></abp-validation-summary>
            </div>

            <div class="form-group row">
              <label class="col-md-2" for="bairro">
                {{ "Bairro" | localize }}
              </label>

              <input type="text" class="col-md-9 form-control" name="bairro" id="bairro" maxlength="256"
                [(ngModel)]="paciente.enderecoAtualizado.bairro" [disabled]="desabilitarCamposEndereco"
                #bairroModel="ngModel" #bairroEl />
              <abp-validation-summary [control]="bairroModel" [controlEl]="bairroEl"></abp-validation-summary>
            </div>

            <div class="form-group row">
              <label class="col-md-2" for="logradouro">
                {{ "Logradouro" | localize }}
              </label>
              <input type="text" class="form-control col-md-9" name="logradouro" id="logradouro" maxlength="80"
                [(ngModel)]="paciente.enderecoAtualizado.logradouro" #logradouroModel="ngModel" #logradouroEl />
              <abp-validation-summary [control]="logradouroModel" [controlEl]="logradouroEl">
              </abp-validation-summary>
            </div>

            <div class="form-group row">
              <label class="col-md-2" for="numero">
                {{ "Numero" | localize }}
              </label>

              <input type="text" onlyAlphanumeric class="col-md-9 form-control" name="numero" id="numero" maxlength="10"
                [(ngModel)]="paciente.enderecoAtualizado.numero" #numeroModel="ngModel" #numeroEl />
              <abp-validation-summary [control]="numeroModel" [controlEl]="numeroEl"></abp-validation-summary>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-md-2" for="complemento">
              {{ "Complemento" | localize }}
            </label>
            <input type="text" class="col-md-9 form-control" name="complemento" id="complemento" maxlength="80"
              [(ngModel)]="paciente.enderecoAtualizado.complemento" #complementoModel="ngModel" #complementoEl />
            <abp-validation-summary [control]="complementoModel" [controlEl]="complementoEl">
            </abp-validation-summary>
          </div>
        </tab>
        <tab heading="Convênios" customClass="pt-7">
          <convenios-paciente [pacienteId]="paciente.id"></convenios-paciente>
        </tab>
      </tabset>
      <div *ngIf="!paciente.hasCadastroCompleto" class="form-group mt-2">
        <div class="col-12 text-center">
          <p>A senha do usuário é composta da seguinte forma: a primeira letra do nome (em maiúscula), a segunda
            letra do nome (em minúscula), os seis primeiros dígitos do CPF e, por fim, um ponto de exclamação (!).
          </p>
          <p>Exemplo: Us123456!</p>
        </div>
      </div>
      <div class="form-group mt-2">
        <div class="col-12 text-center">
          <a href="https://www.prodigius.com.br/termosdeuso" target="_blank">{{
            "TermosUso" | localize }}</a>
        </div>
      </div>
      <div class="form-group">
        <div class="col-12 text-center">
          <a href="https://www.prodigius.com.br/privacidade" target="_blank">{{ "PoliticaPrivacidade" | localize }}</a>
        </div>
      </div>
    </div>
  </app-custom-modal>
</form>